import React, { useMemo } from "react";
import { useData, ADMIN_TABLE } from "../../context/DataContext";
import { cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";

export default function CompletedTasksAdmin() {
  const { adminRecords, loading } = useData();

  // Filter to show ALL master tasks that are completed
  const completed = useMemo(() =>
    adminRecords.filter((r) => {
      const s = cellText(r.fields?.["Overall Status"]).toLowerCase();
      // Statuses that count as completed: "Done", "Completed"
      return s.includes("done") || s.includes("✅") || s.includes("complet");
    }),
    [adminRecords]
  );

  if (loading && adminRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading tasks...</span></div>;

  return (
    <div className="fade-in">
      <div className="page-header">
        <h1>✅ Completed Overall Tasks</h1>
        <p>Master tasks that have been successfully finished — {completed.length} records</p>
      </div>
      <TaskTable 
        tableId={ADMIN_TABLE} 
        records={completed} 
        emptyMsg="No completed master tasks yet."
        canEdit={true}
        canDelete={true}
        statusOptionsOverride={["✅ Done", "🔴 Overdue (Done)"]}
      />
    </div>
  );
}
